export default __webpack_public_path__ + "static/media/data.9f191709.webp";